import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Process } from "@/components/site/Process";
import { Sample } from "@/components/site/Sample";
import { Rules } from "@/components/site/Rules";
import { Pricing } from "@/components/site/Pricing";
import { Contact } from "@/components/site/Contact";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import Admin from "@/pages/Admin";
import Answers from "@/pages/Answers";
import Review from "@/pages/Review";
import { Reviews } from "@/components/site/Reviews";
import { BlogIndex, BlogPost } from "@/pages/Blog";
import FieldPage from "@/pages/FieldPage";
import BulletChecker from "@/pages/BulletChecker";
import Unsubscribe from "@/pages/Unsubscribe";
import { Seo, HOME_SEO } from "@/components/site/Seo";
import { scrollToId } from "@/components/site/SmoothScroll";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => scrollToId(hash), 500);
      return () => clearTimeout(t);
    }
    window.scrollTo(0, 0);
    return undefined;
  }, [pathname, hash]);
  return null;
};

const Landing = () => (
  <SmoothScroll>
    <Seo {...HOME_SEO} />
    <div className="relative min-h-screen overflow-x-clip bg-[var(--ink)]" data-testid="landing-page">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Process />
        <Sample />
        <Rules />
        <Reviews />
        <Pricing />
        <Contact />
      </main>
    </div>
  </SmoothScroll>
);

function App() {
  return (
    <BrowserRouter>
      <ScrollManager />
      <Toaster theme="dark" position="bottom-center" />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/answers/:token" element={<Answers />} />
        <Route path="/review/:token" element={<Review />} />
        <Route path="/blog" element={<BlogIndex />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/resume-help/:field" element={<FieldPage />} />
        <Route path="/bullet-checker" element={<BulletChecker />} />
        <Route path="/unsubscribe" element={<Unsubscribe />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
